window.WorkHistoryAPI = new (function () {
      var self = this;
      var _protected = BaseAPI.call(self);
  
  
      self.add = function(data, first_job){
        var defer = $q.defer(), promises = [],  asyncGlobalHandler = getAngularService('asyncGlobalHandler');
  
        var prepareWorkHistoryPromise = prepareWorkHistoryData(data, first_job);
        promises.push(prepareWorkHistoryPromise);
        prepareWorkHistoryPromise.then(function(work_histories){
          _.each(work_histories, function(work_history){
            promises.push( createNewWorkHistory(work_history) );
          });
        });
  
        $q.all(promises).then(function(data){
          defer.resolve('done');
        }, function(err){
          defer.reject(err);
        });
  
        _.each(promises, function(promise){
          asyncGlobalHandler.watchPromise(promise);
        });
  
  
        return defer.promise;
      };
  
      var createNewWorkHistory = function (data) {
        var defer = $q.defer();
  
  
        //case #1
        if (data.first_job) {
          return _protected.request('work_history', 'PUT', [data]);
        }
  
        //case #2
        var basic_data = [keepAttrs(angular.copy(data), ['brand_name', 'google_place', 'location_id', 'brand_id'])];
  
  
        _protected.request('work_history', 'PUT', basic_data).then(function (r) {
          var extended_data = removeAttrs(angular.copy(data), ['brand_name', 'google_place', 'location_id', 'brand_id']);
  
          if (r && r.data && r.data.data && r.data.data.length && r.data.data[0].Work && r.data.data[0].Work.id) {
            extended_data.work_id = r.data.data[0].Work.id;
          }
  
          _protected.request('work_history', 'POST', extended_data).then(function (r) {
            defer.resolve(r);
          })
        });
  
        return defer.promise;
      };
  
  
      var prepareWorkHistoryData = function (workHistoriesData, first_job) {
  
  
        var d = $q.defer();
        var formattedData = [];
  
        // only first job
        if (first_job) {
          formattedData.push({"first_job": true});
          setTimeout(function(){
            d.resolve(formattedData)
          }, 1);
          return d.promise;
        }
  
  
        //queue holding all google requests.
        var googlePlaces = [], googleMaps = getAngularService('googleMaps');
  
  
        for (var i = 0; i < workHistoriesData.length; i++) {
          var work_history = workHistoriesData[i];
          formattedData[ i ] = {};
          if (work_history.brand && work_history.brand.brand_name) {
            formattedData[ i ].brand_name = work_history.brand.brand_name
            addWorkHistory( work_history, formattedData[ i ] );
          }
          else if (work_history.brand && work_history.brand.place_id) {
  
            (function (place_id, work_history, i) {
              var placeDefer = $q.defer();
              //get locations details
              googleMaps.getDetails({placeId: place_id}, function (r) {
                work_history.google_place = {result: r};
                addWorkHistory(work_history, formattedData[i]);
                placeDefer.resolve();
              });
              googlePlaces.push(placeDefer.promise);
            })(work_history.brand.place_id, work_history, i);
  
          }
          else if (work_history.brand  && work_history.brand.value) {
            formattedData[ i ].brand_id = work_history.brand.value.brand_id;
            formattedData[ i ].location_id = work_history.brand.value.location_id;
            addWorkHistory(workHistoriesData[ i ], formattedData[i]);
          }
        }
  
  
        $q.all(googlePlaces).then(function (responses) {
          d.resolve(formattedData);
        });
  
        return d.promise;
      }
  
  
      /* Private Methods */
      function addWorkHistory(work_history, returnedWH) {
  
        if (work_history.position) {
  
          if (work_history.position.custom_position) {
            returnedWH.custom_position = work_history.position.custom_position;
          }
          else if (work_history.position.value && work_history.position.value.custom_position) {
            returnedWH.custom_position = work_history.position.value.custom_position;
          }
          else {
            returnedWH.position_id = work_history.position.id;
          }
        }
  
        if (work_history.google_location && work_history.google_location.value) {
          if (!work_history.google_place && !work_history.brand_name) {
            returnedWH.location_id = work_history.google_location.value.id;
          }
        }
  
        if( work_history.end_date ){
          returnedWH.end_date = work_history.end_date;
        }
  
        if( work_history.start_date ){
          returnedWH.start_date = work_history.start_date;
        }
  
        if( work_history.google_place ){
          returnedWH.google_place = work_history.google_place;
        }
  
        if( work_history.currently ){
          delete returnedWH.end_date;
          delete work_history.currently;
        }
  
        return returnedWH;
      };

});
